<template>
  <!-- 投保-上门取货-结算确认 成功页面 -->
  <div>
    <div class="bgcenter"></div>
    <div>
      <headbox
        :title="titleinfo"
        bgColor="#fff"
        isborder="true"
        :initback="true"
        @initbackf="backpage"
      ></headbox>
      <!-- 卖出成功 -->
      <div class="centerbox" v-if="sellbool">
        <i class="icon el-icon-success"></i>
        <div class="titlebox">定价提交成功</div>
        <div class="infobox">我们将尽快为您审核,请留意短信通知</div>
        <el-button class="btnbox" @click="pricingRecordslog"
          >查看定价记录</el-button
        >
        <div class="flex-around footerbox">
          <div @click="pickUpPage" class="btnstyle">上门取货</div>
          <div @click="seedata" class="btnstyle">查看行情</div>
        </div>
      </div>
      <!-- 买料成功 -->
      <div class="centerbox" v-if="buybool">
        <i class="icon el-icon-success"></i>
        <div class="titlebox">买料提交成功</div>
        <div class="infobox">我们将尽快为您审核,请留意短信通知</div>
        <el-button class="btnbox" @click="pricingRecordslog"
          >查看买料记录</el-button
        >
        <div class="flex-around footerbox">
          <div @click="pickUpPage" class="btnstyle">上门取货</div>
          <div @click="seedata" class="btnstyle">查看行情</div>
        </div>
      </div>
      <!-- 结算 -->
      <div class="centerbox" v-if="jiesuan">
        <i class="icon el-icon-success"></i>
        <div class="titlebox">您的结算单已确认</div>
        <div class="infobox">飞速打款中，请留意银行短信通知</div>
        <el-button class="btnbox" @click="seedata">
          查看行情
        </el-button>
      </div>
      <!-- 上门结算 -->
      <div class="centerbox" v-if="shangmen">
        <i class="icon el-icon-success"></i>
        <div class="titlebox">预约成功</div>
        <div class="infobox">取货人员正在飞速赶来</div>
        <el-button class="btnbox" @click="claimedit">立即投保</el-button>
        <div class="footerbox " @click="seedata">
          <div class="btnstyle" style="width:100%">查看行情</div>
        </div>
      </div>
      <!-- 注册成功 -->
      <div class="centerbox" v-if="zhuce">
        <i class="icon el-icon-success"></i>
        <div class="titlebox">注册成功</div>
        <div class="infobox"></div>
        <el-button class="btnbox" @click="gologin">前往登录</el-button>
      </div>
      <!-- 重置密码成功 -->
      <div class="centerbox" v-if="chongzhimima">
        <i class="icon el-icon-success"></i>
        <div class="titlebox">重置密码成功</div>
        <div class="infobox"></div>
        <el-button class="btnbox" @click="gologin">前往登录</el-button>
      </div>
      <!-- 投保 -->
      <div class="centerbox" v-if="toubao">
        <!--  -->
        <i class="icon el-icon-success"></i>
        <!-- <img src="@/assets/images/successbox.png" alt=""> -->
        <div class="titlebox">投保申请已提交</div>
        <div class="infobox">稍后可在“我的保险”查看投保结果</div>
        <el-button class="btnbox" @click="myclaim">查看保单</el-button>
        <div class="footerbox " @click="seedata">
          <div class="btnstyle" style="width:100%">返回行情</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headbox from "@/components/head.vue";
export default {
  data() {
    return {
      titleinfo: "",
      sellbool: false,
      jiesuan: false,
      buybool: false,
      shangmen: false,
      toubao: false,
      zhuce: false,
      chongzhimima: false
    };
  },
  mounted() {
    const querytype = this.$route.query.type;
    if (querytype == "sell") {
      this.titleinfo = "卖出";
      this.sellbool = true;
    } else if (querytype == "buy") {
      this.titleinfo = "买料";
      this.buybool = true;
    } else if (querytype == "jiesuan") {
      this.titleinfo = "结算确认";
      this.jiesuan = true;
    } else if (querytype == "shangmen") {
      this.titleinfo = "上门取货";
      this.shangmen = true;
    } else if (querytype == "toubao") {
      this.titleinfo = "投保";
      this.toubao = true;
    } else if (querytype == "zhuce") {
      this.titleinfo = "注册";
      this.zhuce = true;
    } else if (querytype == "chongzhimima") {
      this.titleinfo = "重置密码";
      this.chongzhimima = true;
    }
  },
  methods: {
    backpage() {
      const querytype = this.$route.query.type;
      if (querytype == "sell") {
        this.$router.push({ name: "person" });
      } else if (querytype == "jiesuan") {
        this.$router.push({ name: "person" });
      } else if (querytype == "shangmen") {
        this.$router.push({ name: "person" });
      } else if (querytype == "toubao") {
        this.$router.push({ name: "person" });
      } else if (querytype == "zhuce") {
        this.$router.push({ name: "login" });
      } else if (querytype == "chongzhimima") {
        this.$router.push({ name: "login" });
      }
    },
    // 前往登录
    gologin() {
      this.$router.push({ name: "login" });
    },
    // 查看定价记录
    pricingRecordslog() {
      this.$router.push({ name: "pricingRecords" });
    },
    // 查看保单
    myclaim() {
      this.$router.push({ name: "claim" });
    },
    // 查看详情
    seedata() {
      this.$router.push({ name: "home" });
    },
    // 填写投保信息
    claimedit() {
      this.$router.push({ name: "claimedit" });
    },
    // 上门取货
    pickUpPage() {
      this.$router.push({ name: "pickUp" });
    }
  },
  components: {
    headbox
  }
};
</script>
<style lang="scss" scoped="true">
.btnstyle {
  width: 330px;
  padding: 25px 0;
  border-radius: 5px;
  background: #fff;
}
.bgcenter {
  background: #f7f7f7;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.centerbox {
  position: relative;
  z-index: 2;
  text-align: center;
  i {
    margin-top: 80px;
    display: block;
    font-size: 170px;
    color: #1fc88c;
  }
  .el-button {
    border-radius: 8px;
  }
  .titlebox {
    margin-top: 40px;
    font-size: 36px;
    color: #292929;
  }
  .infobox {
    color: #cccccc;
    margin-top: 20px;
    font-size: 28px;
  }
  .footerbox {
    padding: 0 30px;
    font-size: 32px;
    color: #333333;
  }
  .btnbox {
    width: 90%;
    background: #ffb606;
    color: #fff;
    border: 1px solid #ffb606;
    margin: 70px auto 30px;
    display: block;
    height: 90px;
    font-size: 36px;
  }
  img {
    width: 140px;
    height: 140px;
    margin: 90px auto 0;
    display: block;
  }
}
</style>
